import { render, staticRenderFns } from "./ChatMensagem.vue?vue&type=template&id=d8ed250a&scoped=true"
import script from "./ChatMensagem.vue?vue&type=script&lang=js"
export * from "./ChatMensagem.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagem.vue?vue&type=style&index=0&id=d8ed250a&prod&lang=css"
import style1 from "./ChatMensagem.vue?vue&type=style&index=1&id=d8ed250a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ed250a",
  null
  
)

export default component.exports